import { Injectable } from '@angular/core';
import { BrandInfo } from '../configuration/configuration.types';

/**
 * Service that manages brand-related information like logo, social media links and contact details.
 * This service is used to store and provide access to branding information throughout the application.
 * The information is initialized using the initInfo method which takes a BrandInfo object.
 */
@Injectable({
    providedIn: 'root',
})
export class BrandsService {
    logoUrl?: string;
    websiteUrl?: string;
    instagramUrl?: string;
    facebookUrl?: string;
    xUrl?: string;
    linkedInUrl?: string;
    email?: string;
    phoneNumber?: string;

    initInfo(brandInfo: BrandInfo) {
        this.logoUrl = brandInfo.logoUrl;
        this.websiteUrl = brandInfo.websiteUrl;
        this.instagramUrl = brandInfo.instagramUrl;
        this.facebookUrl = brandInfo.facebookUrl;
        this.xUrl = brandInfo.xUrl;
        this.linkedInUrl = brandInfo.linkedInUrl;
        this.email = brandInfo.email;
        this.phoneNumber = brandInfo.phoneNumber;
    }
}
